const initialState = { 
      "timestamp":0,
      "batch":1,
      "totalRecordCount":0,
      "currentRecordCount":0,
      "searchResultList":[]
};

const searchResultsFilterTorrensReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'FILTER_TORRENS_ID':
                  const document = action.document;      
                  
                  let index = -1;
                  for (let i = 0; i < state["searchResultList"].length; i++) {
                        if (document.id == state.searchResultList[i].id) {
                              index = i;
                              break;
                        }
                  }

                  if (index > -1) { // if found, remove the document
                        state.searchResultList.splice(index, 1); 
                        state.totalRecordCount -= 1
                  } else if (state.totalRecordCount < 100) { // if not found, insert the document
                        state.searchResultList.push(document);
                        if (action.sortKey === 'book') {
                              if (action.sortDirection === 'ASC') {
                                    state.searchResultList.sort((document1, document2) => (document1.book > document2.book) ? 1 : ((document2.book > document1.book) ? -1 : 0))
                              } else {
                                    state.searchResultList.sort((document1, document2) => (document2.book > document1.book) ? 1 : ((document1.book > document2.book) ? -1 : 0))
                              }
                        } else if (action.sortKey === 'certificateNumber') {
                              if (action.sortDirection === 'ASC') {
                                    state.searchResultList.sort((document1, document2) => (document1.certificateNumber > document2.certificateNumber) ? 1 : ((document2.certificateNumber > document1.certificateNumber) ? -1 : 0))
                              } else {
                                    state.searchResultList.sort((document1, document2) => (document2.certificateNumber > document1.certificateNumber) ? 1 : ((document1.certificateNumber > document2.certificateNumber) ? -1 : 0))
                              }
                        } else if (action.sortKey === 'certifiedDate') {
                              if (action.sortDirection === 'ASC') {
                                    state.searchResultList.sort((document1, document2) => (document1.certifiedDateComparing > document2.certifiedDateComparing) ? 1 : ((document2.certifiedDateComparing > document1.certifiedDateComparing) ? -1 : 0))
                              } else {
                                    state.searchResultList.sort((document1, document2) => (document2.certifiedDateComparing > document1.certifiedDateComparing) ? 1 : ((document1.certifiedDateComparing > document2.certifiedDateComparing) ? -1 : 0))
                              }
                        }
                        state.totalRecordCount += 1
                  }             
                  state.timestamp += 1;
                  return state;
            
            case 'SORT_FILTERED_TORRENS':
                  if (action.sortKey === 'book') {
                        if (action.sortDirection === 'ASC') {
                              state.searchResultList.sort((document1, document2) => (document1.book > document2.book) ? 1 : ((document2.book > document1.book) ? -1 : 0))
                        } else {
                              state.searchResultList.sort((document1, document2) => (document2.book > document1.book) ? 1 : ((document1.book > document2.book) ? -1 : 0))
                        }
                  } else if (action.sortKey === 'certificateNumber') {
                        if (action.sortDirection === 'ASC') {
                              state.searchResultList.sort((document1, document2) => (document1.certificateNumber > document2.certificateNumber) ? 1 : ((document2.certificateNumber > document1.certificateNumber) ? -1 : 0))
                        } else {
                              state.searchResultList.sort((document1, document2) => (document2.certificateNumber > document1.certificateNumber) ? 1 : ((document1.certificateNumber > document2.certificateNumber) ? -1 : 0))
                        }
                  } else if (action.sortKey === 'certifiedDate') {
                        if (action.sortDirection === 'ASC') {
                              state.searchResultList.sort((document1, document2) => (document1.certifiedDateComparing > document2.certifiedDateComparing) ? 1 : ((document2.certifiedDateComparing > document1.certifiedDateComparing) ? -1 : 0))
                        } else {
                              state.searchResultList.sort((document1, document2) => (document2.certifiedDateComparing > document1.certifiedDateComparing) ? 1 : ((document1.certifiedDateComparing > document2.certifiedDateComparing) ? -1 : 0))
                        }
                  }
                  return state;
            
            case 'UPDATE_SEARCH_RESULTS':    
            case 'LOGOUT_USER':
                  return {
                        "timestamp":0,
                        "totalRecordCount":0,
                        "currentRecordCount":0,
                        "searchResultList":[]   
                  }
            default:
                  break;
      }
      return state;
};
export default searchResultsFilterTorrensReducer;